import type { Language } from '@inflearn/i18n-tools';

/**
 * 전자상거래법 시행령 27조의3(후기 정보 공개) 대응용 "수강평 운영정책" 안내글 ID.
 * 본문은 어드민 > 안내글 관리에서 언어별로 편집한다. 개발·운영 서버 모두 같은 ID다. (PLAYER-2835)
 */
export const REVIEW_POLICY_GUIDE_ID: Record<Language, number> = {
  ko: 633,
  en: 636,
  ja: 635,
  vi: 634,
};
